import { useContext, useRef,useEffect,useState} from 'react';
import { useForm } from 'react-hook-form';
import { SidebarContext } from 'context/SidebarContext';
import FixedItineraryServices from 'services/FixedItineraryServices';
import { notifyError, notifySuccess } from 'utils/toast';

const useFixedItinerarySubmit = (id, setStatus, setPackageCode, packageCode) => {
  const { isDrawerOpen,closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedCityArrival, setSelectedCityArrival] = useState(null);
  const [selectedCityNameArrival, setSelectedCityNameArrival] = useState(null);
  const [selectedCityDeparture, setSelectedCityDeparture] = useState(null);
  const [selectedCityNameDeparture, setSelectedCityNameDeparture] = useState(null);
  const [dataInput, setDataInput] = useState([]);
  const [dataInputPrice, setDataInputPrice] = useState([{"vehicle_type_0":"","rate_0":"","prime_0":""}]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [cityValues, setCityValues] = useState([]);
  const [noOfNights, setNoOfNights] = useState("");
  const [noOfDays, setNoOfDays] = useState("");
  const [kmlimit, setkmlimit] = useState("");
  const [primeAvailable, setPrimeAvailable] = useState();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    clearErrors,
    trigger,
    getValues,
    setError,
    formState: { errors },
  } = useForm();
  const handleVehicleCategoryChange = (e, index) => {
    const { name,value } = e.target;
    //selected value
    const onChangeVals = [...dataInputPrice];
    onChangeVals[index][name] = value;
    setDataInputPrice(onChangeVals);
    // selected options
    const updatedSelectedOptions = [...selectedOptions];
    updatedSelectedOptions[index] = value;
    setSelectedOptions(updatedSelectedOptions);
  };
  const handleChangeInputPrice = (e, i) => {
    if(e&&e.target){
    const { name, value } = e.target;
    const onChangeVal = [...dataInputPrice];
    onChangeVal[i][name] = value;
    setDataInputPrice(onChangeVal);
    }
  };

  const handleChangeInput = (e, i, names = null) => {
    
    const onChangeVal = [...dataInput];
  
    if (e && e.target) {
      const { name, value } = e.target;
      onChangeVal[i][name] = value;
    } else if (names) {
      onChangeVal[i][names] = e;
    }
  
    setDataInput(onChangeVal);
  };


  const handleCityChange = (selectedCity, i,name) => {
    // Update the city selection
    setCityValueForIndex(i, selectedCity);
  
    // Update the input field
    handleChangeInput(selectedCity, i,name);
  };
  const setCityValueForIndex = (index, cityValue) => {
    const updatedCityValues = [...cityValues];
    updatedCityValues[index] = cityValue;
    setCityValues(updatedCityValues);
  };
  
  const myPriceRef = useRef(null);

  useEffect(() => {
    if (myPriceRef.current) {
      myPriceRef.current.focus();
    }
  }, []);
  
  
  const no_of_days = myPriceRef?.current?.value;
  
  useEffect(() => {
    setDataInput((prevDataInput) => {
      const newData = [];
      if(prevDataInput&&prevDataInput.length<no_of_days){
        var count=no_of_days-prevDataInput.length;
      for (let i = prevDataInput.length; i < (prevDataInput.length+count); i++) {
        newData.push({
          [`day_${i}`]: `Day ${i+1}`,
          [`from_${i}`]: "",
          [`to_${i}`]: "",
          [`from_name_${i}`]: "",
          [`to_name_${i}`]: "",
          [`km_${i}`]: "",
          [`duration_${i}`]: "",
          [`itinerary_${i}`]: "",
        });
      }
      return [...prevDataInput, ...newData];
    }
    else if(prevDataInput&&prevDataInput.length>no_of_days){
        return [...prevDataInput.slice(0, no_of_days - prevDataInput.length)];
    }
    else{
       return [...prevDataInput, ...newData];
    }
      
    });
  }, [no_of_days]);
  

  const handleChangesNights = (value) => {
    setNoOfNights(value);
  };
  const handleChanges = (value) => {
    setkmlimit(value);
  };
  const handleChangesDays = (value) => {
    setNoOfDays(value);
  };
  const handleCityChangeArrival = (city_id) => {
    setSelectedCityArrival(city_id);
  };
  const handleCityChangeNameArrival = (value)=>{
    setSelectedCityNameArrival(value);
  }
  const handleCityChangeNameDeparture = (value)=>{
    setSelectedCityNameDeparture(value);
  }
  const handleCityChangeDeparture = (city_id) => {
    setSelectedCityDeparture(city_id);
  };
  const handleNextStep = async() => {
    
    await Promise.all([validateForm()]);
    if(step === 1 || step === 2){
      clearErrors(['start_date', 'end_date']);
    }
    if (Object.keys(errors).length === 0) {
     
      if(step!==3){
        setStep(step + 1);
      }
      else{
        handleSubmit(onSubmit);
      }

    }
    else{
      
      return notifyError(`Please provide all the Details`);  
    }
  };
  const handlePreviousStep = async () => {
        setStep(step - 1);
  };
  const goToStep = async (stepNumber) => {
    await Promise.all([validateForm()]);
    if (Object.keys(errors).length === 0) {
      setStep(stepNumber);
    }
    else{
      return notifyError(`Please provide all the Details`);  
    }
  };
  const validateForm = async () => {
    await trigger();
    return Object.keys(errors).length;
    
  }

  const handleStartDateChange = (event) => {
    const selectedStartDate = event;
    setStartDate(selectedStartDate);
    // setEndDate(selectedStartDate);
  };

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const dataValues={};
      const vehicleTypeValues=dataInputPrice.map((item)=> parseInt(item[Object.keys(item)[0]]));
       const PriceValues = dataInputPrice.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[1]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
      const PrimeValues = dataInputPrice.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[2]];
        if(value !== undefined){
          value = Number(value).toString();
        }else{
          value = "0"
        }
       
        accumulator[key] = value;
        return accumulator;
      }, {});
      dataValues.route=data.route;
      if(id){
        dataValues.package_code =  data.package_code;
      }else{
        dataValues.package_code = packageCode;
      }
      
      dataValues.kilometer_limit=kmlimit;
      dataValues.no_of_days=noOfDays;
      dataValues.no_of_nights=noOfNights;
      dataValues.arrival=selectedCityArrival;
      dataValues.departure=selectedCityDeparture;
      dataValues.itinerary=dataInput;
      dataValues.vehicle_type=vehicleTypeValues;
      dataValues.rate=PriceValues;
      dataValues.prime=PrimeValues;
      dataValues.start_from = startDate.toLocaleDateString("en-GB");
      dataValues.end_to = endDate.toLocaleDateString("en-GB");
      //console.log(dataValues);
      setIsSubmitting(true);

      if (id) {
        const res = await FixedItineraryServices.updateFixedItinerary(id, dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        setStatus(false);
        closeDrawer();
      }
      else {
        const res = await FixedItineraryServices.addFixedItinerary(dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        setStatus(false);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err.message);
      setIsSubmitting(false);
     // closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const res = await FixedItineraryServices.getFixedItineraryById(id);
          if (res) {
            setValue('route', res.route);
            setkmlimit(res.kilometer_limit);
            setValue('kilometer_limit',res.kilometer_limit);
            setValue('package_code', res.package_code);
            setPackageCode(res.package_code);
            setNoOfNights(res.no_of_nights);
            setNoOfDays(res.no_of_days);
            setSelectedCityArrival(res.arrival);
            setSelectedCityDeparture(res.departure);
            setPrimeAvailable(res.prime_available);
            setDataInput(res.itinerary);
            setEndDate(new Date(res.end_to));
            setStartDate(new Date(res.start_from));
            const FormWholeArray=[];
            if(res.vehicle_type){
              res.vehicle_type.forEach((item,index)=>{
                let obj={};
                obj['vehicle_type_'+index]=item; 
                obj['rate_'+index]=res['rate'][item]; 
                obj['prime_'+index]=res['prime'][item];
                FormWholeArray.push(obj);
              });
              setDataInputPrice(FormWholeArray);
              setSelectedOptions(res.vehicle_type);
            }
          }
        } catch (err) {
          notifyError(err ? err?.response?.data?.message : err.message);
        }
      })();
    }
    if (!isDrawerOpen) {
      setTimeout(() => {
        reset({
          route: "",
          kilometer: "",
          no_of_nights: "",
          no_of_days: "",
          arrival: "",
          departure: ""
        });
        setStep(1);
        setStatus(false);
        setValue("route");
        setValue("package_code");
        setkmlimit("");
        setStartDate(null);
        setEndDate(null);
        setNoOfNights("");
        setNoOfDays("");
        setDataInput([]);
        setSelectedCityArrival(null);
        setSelectedCityDeparture(null);
        setDataInputPrice([{"vehicle_type_0":"","rate_0":""}]);
        setSelectedOptions([]);
        clearErrors(); 
      }, 100);
   
      clearErrors(); 
      return;
    }
    
    // eslint-disable-next-line
  }, [id, setValue, isDrawerOpen, clearErrors]);

  return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    setValue,
    errors,
    handleNextStep,
    step,
    setStep,
    handlePreviousStep,
    goToStep,
    setSelectedCityArrival,
    setSelectedCityDeparture,
    selectedCityArrival,
    selectedCityNameArrival,
    selectedCityDeparture,
    selectedCityNameDeparture,
    isSubmitting,
    dataInput,
    handleChanges,
    kmlimit,
    handleCityChangeArrival,
    handleCityChangeNameArrival,
    handleCityChangeNameDeparture,
    handleCityChangeDeparture,  
    handleChangeInput,
    handleCityChange,
    handleChangesNights,
    handleChangesDays,
    noOfDays,
    noOfNights,
    myPriceRef,
    setSelectedOptions,
    selectedOptions,
    handleVehicleCategoryChange,
    setDataInputPrice,
    dataInputPrice,
    handleChangeInputPrice,
    loading,
    setLoading,
    setDataInput,
    setStartDate,
    startDate,
    handleStartDateChange,
    setEndDate,
    endDate,getValues,setError, clearErrors, primeAvailable
  };
};

export default useFixedItinerarySubmit;
